<template>
  <div id="container" ref="max">
    <!-- 表格上方按钮 -->
    <div class="topBtn" :style="{justifyContent:hasAddBtn?'space-between':'space-between'}" v-if="hasBtn">
      <div class="table">
        <div class="tableTitle">
          <div class="titleTxt">{{ tableTitle }}</div>
        </div>
      </div>
      <div class="right">
        <el-button
          type="text"
          class="btnTxt"
          v-if="showAddButton"
          @click="addClick()"
        >
          <span style="color: #fff;">新增</span>
        </el-button>
        <el-button
          type="text"
          class="btnTxt"
          v-if="showExportButton"
          @click="exportClick()"
        >
          <span style="color: #fff;">导出</span>
        </el-button>
        <!-- 搜索 -->
        <div class="search" v-if="showSearch">
          <el-input
            :placeholder="searchPlaceholder"
            v-model="searchValue"
            @keyup.enter.native="searchClick()"
          >
            <div slot="suffix" class="searchClass" @click="searchClick()">搜索</div>
          </el-input>
        </div>
      </div>
    </div>
    <!-- 表格 -->
    <div class="table">
      <!-- 表格标题 -->
      <!-- <div class="tableTitle">
        <div class="titleTxt">{{ tableTitle }}</div>
      </div> -->
      <div class="tableContent" ref="tableContent">
        <el-table
          :data="tableData"
          :ref="tableRef"
          :height="tableHeight"
          v-if="tableHeight"
          tooltip-effect="light"
        >
          <el-table-column
            v-for="(column, index) in tableColumn"
            :key="index"
            :prop="column.prop"
            :label="column.label"
            align="center"
            min-width="65"
            :show-overflow-tooltip="true"
            >
          </el-table-column>
          <!-- 自定义内容列 -->
          <slot name="customCol"></slot>
          <!-- 操作列 -->
          <el-table-column
            label="操作"
            align="center"
            min-width="120"
            v-if="actions.length"
          >
            <template slot-scope="scope">
              <span v-for="item in actions" :key="item.type">
                <!-- 根据类型渲染对应按钮 -->
                <!-- 查看 -->
                <el-button
                  v-if="item.type === 'view'"
                  @click="detailClick(scope.row)"
                  type="text"
                  size="small"
                >
                  {{ item.label }}
                </el-button>
                <!-- 修改 -->
                <el-button
                  v-if="item.type === 'edit'"
                  @click="editClick(scope.row)"
                  type="text"
                  size="small"
                >
                  {{ item.label }}
                </el-button>
                <!-- 删除 -->
                <el-button
                  v-if="item.type === 'delete'"
                  @click="deleteClick(scope.row.id)"
                  type="text"
                  size="small"
                >
                  {{ item.label }}
                </el-button>
              </span>
              <slot name="extraBtn" :row="scope.row"></slot>
            </template>
          </el-table-column>
          <!-- 自定义操作列-->
          <slot name="customBtn"></slot>
        </el-table>
      </div>
    </div>
    <!-- 分页器 -->
    <div id="pages">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page="current"
        :page-sizes="[6, 12, 18, 24]"
        :page-size="size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        popper-class="adminHomeSelect"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { emit } from 'node-notifier';

  export default {
    name: "BasicTable",
      // tableColumn: [], // 列配置 label-列名，prop-对应列的字段名
      // tableData: [], // 列表内容数据
      // actions: [], //是否有操作列 label-按钮名，type-按钮类型
    props: {
      searchPlaceholder: {
        type: String,
        required: false,
        default: function() {
          return '请输入'; //
        }
      },
      tableColumn: {
        type: Array,
        required: true,
      },
      tableData: {
        type: Array,
        required: true,
      },
      actions: {
        type: Array,
        required: false,
        default: function() {
          return []; // 不传actions默认没有操作列
        }
      },
      showAddButton: {
        type: Boolean,
        required: false,
      },
      showExportButton: {
        type: Boolean,
        required: false,
      },
      showSearch: {
        type: Boolean,
        required: false,
      },
      tableTitle: {
        type: String,
        required: true,
      },
      tableRef: {
        type: String,
        required: false,
      },
      // 自定义表格高度，允许多个表格在同一个页面展示，参数表示除表格外其他区域高度
      otherHeight: {
        type: Number,
        required: false,
        default: 245,
      },
      // 两个表格在同一个页面
      isPart: {
        type: Boolean,
        required: false,
        default: false,
      },
      // 用于区别是否有新增按钮布局不同
      hasAddBtn: {
        type: Boolean,
        required: false,
        default: true,
      },
      // 分页器
      current: {
        type: Number,
        required: false,
        default: 1,
      },
      size: {
        type: Number,
        required: false,
        default: 18,
      },
      total: {
        type: Number,
        required: false,
        default: 0,
      },
      // 表格头部是否有按钮区
      hasBtn: {
        type: Boolean,
        required: false,
        default: true,
      }
    },
    emit: [],
    data() {
      return {
        tableHeight: 0,
        searchValue: '',
      };
    },
    mounted() {
      let _this = this;
      window.onresize = () => {
        if (_this.resizeFlag) {
          clearTimeout(_this.resizeFlag);
        }
        _this.resizeFlag = setTimeout(() => {
          _this.getTableHeight();
          _this.resizeFlag = null;
        }, 100);
      };
    },
    created() {
      this.getTableHeight();
    },
    methods: {
      //TODO 获取数组渲染
      addClick() {
        this.$emit('add-item') //触发新增操作
      },
      exportClick() {
        this.$emit('export-item') //触发导出操作
      },
      detailClick(item) {
        this.$emit('detail-item', item) //触发查看操作
      },
      editClick(item) {
        this.$emit('edit-item', item) //触发修改操作
      },
      deleteClick(itemId) {
        let tips = "<i class='el-icon-warn-tip'></i>是否确认删除?";
        this.$confirm(tips, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          customClass: "customClass-style",
          iconClass: "",
          dangerouslyUseHTMLString: true,
          confirmButtonClass: "confirm-style",
          cancelButtonClass: "cancel-style",
        })
        .then(() => {
          this.$emit('delete-item', itemId) //触发删除操作
        })
        .catch((err) => {
        });
      },
      getTableHeight() {
        let tableH = this.otherHeight; // 除表格外其他区域高度
        let tableHeightDetil = window.innerHeight - tableH;
        if(!this.isPart) {
          if (tableHeightDetil <= 300) {
            this.tableHeight = 300;
          } else {
            this.tableHeight = tableHeightDetil;
          }
        } else {
          if (tableHeightDetil <= 400) {
            this.tableHeight = 180;
          } else {
            this.tableHeight = tableHeightDetil/2-100;
            // this.tableHeight = tableHeightDetil/2-70;
          }
        }
      },
      searchClick() {
        // console.log('模糊搜索', this.searchValue)
        this.$emit('search-item', this.searchValue) //触发搜索操作
      },
      sizeChange(size) {
        this.$emit('size-change', size) // 改变每页条数
      },
      currentChange(current) {
        this.$emit('current-change', current) //改变当前页
      },
    },
  };
</script>
<style scoped>
  @import "../../src/assets/css/common/BasicTable.css";
</style>
<style>
/* 表格字体 */
.el-button--text {
    color: #00AEFF !important;
  }
</style>



// WEBPACK FOOTER //
// src/common/BasicTable.vue